const Loader = ({ fullPage = true }) => {
  const spinner = (
    <div className="flex flex-col items-center gap-4">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary-200 border-t-primary-500" />
      <p className="text-sm text-gray-500">Loading...</p>
    </div>
  );

  if (!fullPage) {
    return spinner;
  }

  return (
    <div className="flex items-center justify-center h-screen w-full bg-white">
      {spinner}
    </div>
  );
};

export default Loader;
